/* eslint-disable max-classes-per-file */
import { useMemo } from "react";
import TicketColumnGroup from "./ticket-group";
import { DashboardGroupBy } from "../../__generated__/api";

export default class TicketColumnGroupCache {
    public static useGroupCache() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useMemo(() => new TicketColumnGroupCache({}), []);
    }

    // eslint-disable-next-line no-useless-constructor
    private constructor(
        private groupMap: Record<string, TicketColumnGroup>,
    ) {
        // none
    }

    public get(context: DashboardGroupBy, ticketStateId: string, groupId: string) {
        return this.groupMap[`${context}-${ticketStateId}-${groupId}`];
    }

    public put(context: DashboardGroupBy, ticketStateId: string, groupId: string, group: TicketColumnGroup) {
        this.groupMap[`${context}-${ticketStateId}-${groupId}`] = group;
    }
}
